import { createSlice } from "@reduxjs/toolkit";
import { getSchoolFacilityList, getSchoolFacilityDetail, saveSchoolFacility, deleteSchoolFacility } from "../controller/schoolFacility.controller";
import { SchoolFacility } from "../types/schoolFacilityType";
import { SaveResponse } from "../types/common";

interface SchoolFacilityState {
  loading: boolean;
  list: SchoolFacility[];
  total: { pages: number; data: number };
  detail: SchoolFacility | null;
  detailLoading: boolean;
  response: SaveResponse | null;
  error: string | null;
}

const initialState: SchoolFacilityState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  detail: null,
  detailLoading: false,
  response: null,
  error: null,
};

const schoolFacilitySlice = createSlice({
  name: "schoolFacility",
  initialState,
  reducers: {
    resetSchoolFacilityResponse: (state) => {
      state.response = null;
    },
    resetSchoolFacilityDetail: (state) => {
      state.detail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSchoolFacilityList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSchoolFacilityList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getSchoolFacilityList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data fasilitas";
      })
      .addCase(getSchoolFacilityDetail.pending, (state) => {
        state.detailLoading = true;
        state.detail = null;
      })
      .addCase(getSchoolFacilityDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detail = action.payload.data ?? null;
      })
      .addCase(getSchoolFacilityDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.error.message ?? "Gagal memuat detail fasilitas";
      })
      .addCase(saveSchoolFacility.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveSchoolFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveSchoolFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan fasilitas";
      })
      .addCase(deleteSchoolFacility.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetSchoolFacilityResponse, resetSchoolFacilityDetail } = schoolFacilitySlice.actions;
export default schoolFacilitySlice.reducer;
